import { Column, Container, Padding, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { C2Text, T3Text } from "../../../common/components/text/CustomText";
import CustomGaugeChart from "../../../common/components/chart/CustomGaugeChart";
import Translate from "../../../common/translate/Translate";
import { useWindowSize } from "../../../common/hooks/useWindowSize";
import { Theme } from "../../../common/Theme";

function DeviceGaugeCard({ type, workingValue, errorValue, vacantValue, notAvailableValue }) {
    let icon;
    let title;
    let titleColor;
    let titleBackgroundColor;
    let gaugeBaseColor;
    let gaugeBarColor;
    const totalValue = workingValue + errorValue + vacantValue + notAvailableValue;
    const rawPercentage = totalValue > 0 ? (workingValue / totalValue) * 100 : 0;
    const percentage = Math.round(rawPercentage);

    const { width } = useWindowSize();

    if (type === "washer") {
        icon = "washer";
        title = Translate("common.washer");
        titleColor = Theme.color.cyan700;
        titleBackgroundColor = Theme.color.cyan700_01;
        gaugeBaseColor = Theme.color.cyan500_01;
        gaugeBarColor = Theme.color.sky800;
    } else if (type === "dryer") {
        icon = "dryer";
        title = Translate("common.dryer");
        titleColor = Theme.color.orange600;
        titleBackgroundColor = Theme.color.red500_01;
        gaugeBaseColor = Theme.color.red500_01;
        gaugeBarColor = Theme.color.orange600;
    } else if (type === "combo") {
        icon = "combo";
        title = Translate("common.combo");
        titleColor = Theme.color.indigo500;
        titleBackgroundColor = Theme.color.indigo500_01;
        gaugeBaseColor = Theme.color.indigo500_01;
        gaugeBarColor = Theme.color.indigo500;
    }

    let textAreaWidth = width <= 700 ? "70%" : "50%";

    return (
        <SizedBox
            height={"100%"}
            width={"100%"}
            border={`1px solid ${Theme.color.gray200}`}
            borderRadius={"16px"}
            justifyContent={"flex-start"}
        >
            <SizedBox
                backgroundColor={titleBackgroundColor}
                width={"100%"}
                height={"52px"}
                borderTopLeftRadius={"16px"}
                borderTopRightRadius={"16px"}
            >
                <Row justifyContent={"flex-start"} alignItem={"flex-start"} padding={"0 16px"} width={"100%"}>
                    <CustomIcon iconName={icon} size={"24px"} />
                    <SizedBox width={"8px"} />
                    <Padding padding={"2px 0 0 0"}>
                        <T3Text fontColor={titleColor} fontWeight={"600"}>
                            {title}
                        </T3Text>
                    </Padding>
                </Row>
            </SizedBox>
            <Row width={"100%"} padding={"0 36px"} flex={"1"} justifyContent={"flex-start"} alignItem={"center"}>
                <SizedBox width={width <= 440 ? "100%" : "40%"} height={width <= 1700 ? "202px" : "101px"}>
                    <CustomGaugeChart
                        label={Translate("store.rateOfUse")}
                        percentage={percentage}
                        baseColor={gaugeBaseColor}
                        barColor={gaugeBarColor}
                    />
                </SizedBox>
                {width >= 440 && (
                    <>
                        <Column alignItem={"flex-end"} flex={"1"} justifyContent={"space-between"} minWidth={"150px"}>
                            <Row justifyContent={"flex-end"} width={textAreaWidth}>
                                <Row justifyContent={"space-between"} width={"100%"}>
                                    <Container>
                                        <CustomIcon iconName={"refresh_purple"} size={"24px"} />
                                        <SizedBox width={"8px"} />
                                        <Column alignItem={"flex-start"}>
                                            <C2Text fontColor={Theme.color.gray500} fontWeight={"500"}>
                                                {Translate("store.deviceStatus.currentlyWorking1")}
                                            </C2Text>
                                            <C2Text fontColor={Theme.color.gray500} fontWeight={"500"}>
                                                {Translate("store.deviceStatus.currentlyWorking2")}
                                            </C2Text>
                                        </Column>
                                    </Container>
                                    <Row>
                                        <T3Text>{String(workingValue).padStart(2, "0")}</T3Text>
                                        <SizedBox width={"4px"} />
                                        <C2Text>/{totalValue}</C2Text>
                                    </Row>
                                </Row>
                            </Row>

                            <SizedBox height={"20px"} />
                            <Row justifyContent={"flex-end"} width={textAreaWidth}>
                                <Row justifyContent={"space-between"} width={"100%"}>
                                    <Container>
                                        <CustomIcon iconName={"alert_triangle"} size={"24px"} />
                                        <SizedBox width={"8px"} />
                                        <Column alignItem={"flex-start"}>
                                            <C2Text fontColor={Theme.color.gray500} fontWeight={"500"}>
                                                {Translate("store.deviceStatus.error")}
                                            </C2Text>
                                        </Column>
                                    </Container>
                                    <Row>
                                        <T3Text>{String(errorValue).padStart(2, "0")}</T3Text>
                                        <SizedBox width={"4px"} />
                                        <C2Text>/{totalValue}</C2Text>
                                    </Row>
                                </Row>
                            </Row>
                            <SizedBox height={"24px"} />
                            <Row justifyContent={"flex-end"} width={textAreaWidth}>
                                <Row justifyContent={"space-between"} width={"100%"}>
                                    <Container>
                                        <CustomIcon iconName={"green_loader"} size={"24px"} />
                                        <SizedBox width={"8px"} />
                                        <Column alignItem={"flex-start"}>
                                            <C2Text fontColor={Theme.color.gray500} fontWeight={"500"}>
                                                {Translate("store.deviceStatus.vacant")}
                                            </C2Text>
                                        </Column>
                                    </Container>
                                    <Row>
                                        <T3Text>{String(vacantValue).padStart(2, "0")}</T3Text>
                                        <SizedBox width={"4px"} />
                                        <C2Text>/{totalValue}</C2Text>
                                    </Row>
                                </Row>
                            </Row>
                            <SizedBox height={"20px"} />
                            <Row justifyContent={"flex-end"} width={textAreaWidth}>
                                <Row justifyContent={"space-between"} width={"100%"}>
                                    <Container>
                                        <CustomIcon iconName={"black_out_grey"} size={"24px"} />
                                        <SizedBox width={"8px"} />
                                        <Column alignItem={"flex-start"}>
                                            <C2Text fontColor={Theme.color.gray500} fontWeight={"500"}>
                                                {Translate("store.deviceStatus.notAvailable1")}
                                            </C2Text>
                                            <C2Text fontColor={Theme.color.gray500} fontWeight={"500"}>
                                                {Translate("store.deviceStatus.notAvailable2")}
                                            </C2Text>
                                        </Column>
                                    </Container>
                                    <Row>
                                        <T3Text>{String(notAvailableValue).padStart(2, "0")}</T3Text>
                                        <SizedBox width={"4px"} />
                                        <C2Text>/{totalValue}</C2Text>
                                    </Row>
                                </Row>
                            </Row>
                        </Column>
                    </>
                )}
            </Row>
        </SizedBox>
    );
}

export default DeviceGaugeCard;
